export const NEW_ONBOARDING_EXISTING_USER = 'new_onboarding_existing_user';
export const REQUEST_PUSH_PERMISSIONS = 'request_push_permissions';
export const SHOW_AVATAR_TOOLTIP = 'show_avatar_tooltip';
export const EMAIL_VERIFIED = 'email_verified';
export const DESKTOP_STOP_REC_TOOLTIP = 'desktop_stop_rec_tooltip';
export const TRIAL_USE_PRO_FEATURE_CUSTOM_DIMENSIONS =
  'pro_feature_custom_dimensions';
export const TRIAL_USE_PRO_FEATURE_HD_RECORDINGS = 'pro_feature_hd_recordings';
export const CHROME_EXT_TRIAL_PRO_FEATURES_WARN_BANNER =
  'chrome_extension_trial_pro_features_banner';
export const CHROME_EXT_PRO_TRIAL_OVERLAY_MODAL =
  'chrome_extension_pro_trial_overlay_modal';

export const CHROME_EXT_TRIAL_ENDED_PRE_REC_MENU_BANNER =
  'chrome_extension_trial_ended_pre_recording_menu_banner';
export const DESKTOP_TRIAL_ENDED_PRE_REC_MENU_BANNER =
  'desktop_trial_ended_pre_recording_menu_banner';
export const SHOW_NEW_GET_STARTED_CHECKLIST_BANNER =
  'website_show_new_get_started_checklist_banner';
export const EXTENSION_GMAIL_INTEGRATION_COMPOSER_TOOLTIP =
  'extension_gmail_integration_composer_tooltip';
export const GMAIL_INTEGRATION_SHARE_PAGE_UPSELL =
  'gmail_integration_share_page_upsell';

export const LOOM_GREETINGS_STARTUP_INSTRUCTION_MODAL =
  'loom_greetings_startup_modal';
export const LOOM_GREETINGS_RECORDING_INSTRUCTION_TOOLTIP =
  'loom_greetings_recording_instruction_tooltip';

export const EDUCATION_USER_UPGRADED_MODAL = 'education_user_upgraded_modal';
export const NEW_TRANSCRIPT_EXPERIENCE_OWNER =
  'new_transcript_experience_owner';
export const NEW_TRANSCRIPT_EXPERIENCE_VIEWER =
  'new_transcript_experience_viewer';

export const SHOW_FIRST_VIDEO_SHARE_MODAL = 'show_first_video_share_modal';
export const SHOW_GET_STARTED_CHECKLIST = 'show_get_started_checklist';
export const SHOW_FIRST_CAPTION_EXPERIENCE = 'show_first_caption_experience';
export const SHOW_DOWNLOAD_VIDEO_INFO_MODAL = 'show_download_video_info_modal';
export const SHOW_WEB_PERMISSIONS_PROMPT = 'show_web_permissions_prompt';
export const SHOW_FIRST_FILLER_REMOVAL_EXPERIENCE =
  'show_first_filler_removal_experience';
export const SHOW_REVIEW_TRANSCRIPT_BUTTON_HIGHLIGHT =
  'show_review_transcript_button_highlight';
export const SHOW_MOBILE_BANNER_PROMPT_ON_SHARE_PAGE =
  'show_mobile_banner_prompt';
export const SHOW_DATA_RETENTION_WARNING = 'show_data_retention_warning';
export const SHOW_MEMBER_VIDEO_THRESHOLD_BANNER =
  'show_member_video_threshold_banner';

export const SHOW_CAMFORT_FTUX = 'show_camfort_ftux';
export const SHOW_TRANSCRIPT_CORRECTION_FTUX =
  'show_transcript_correction_ftux';
export const SHOW_CONTINUE_WATCHING_BANNER = 'show_continue_watching_banner';
export const SHOW_CANVAS_FTUX = 'show_canvas_ftux';
export const SHOW_NON_DEFAULT_WORKSPACE_BANNER =
  'show_non_default_workspace_banner';

export const ALL = [
  NEW_ONBOARDING_EXISTING_USER,
  REQUEST_PUSH_PERMISSIONS,
  SHOW_AVATAR_TOOLTIP,
  EMAIL_VERIFIED,
  DESKTOP_STOP_REC_TOOLTIP,
  TRIAL_USE_PRO_FEATURE_CUSTOM_DIMENSIONS,
  TRIAL_USE_PRO_FEATURE_HD_RECORDINGS,
  CHROME_EXT_TRIAL_PRO_FEATURES_WARN_BANNER,
  CHROME_EXT_PRO_TRIAL_OVERLAY_MODAL,
  CHROME_EXT_TRIAL_ENDED_PRE_REC_MENU_BANNER,
  DESKTOP_TRIAL_ENDED_PRE_REC_MENU_BANNER,
  SHOW_NEW_GET_STARTED_CHECKLIST_BANNER,
  EXTENSION_GMAIL_INTEGRATION_COMPOSER_TOOLTIP,
  GMAIL_INTEGRATION_SHARE_PAGE_UPSELL,
  LOOM_GREETINGS_STARTUP_INSTRUCTION_MODAL,
  LOOM_GREETINGS_RECORDING_INSTRUCTION_TOOLTIP,
  EDUCATION_USER_UPGRADED_MODAL,
  NEW_TRANSCRIPT_EXPERIENCE_OWNER,
  NEW_TRANSCRIPT_EXPERIENCE_VIEWER,
  SHOW_FIRST_VIDEO_SHARE_MODAL,
  SHOW_GET_STARTED_CHECKLIST,
  SHOW_FIRST_CAPTION_EXPERIENCE,
  SHOW_DOWNLOAD_VIDEO_INFO_MODAL,
  SHOW_WEB_PERMISSIONS_PROMPT,
  SHOW_FIRST_FILLER_REMOVAL_EXPERIENCE,
  SHOW_MOBILE_BANNER_PROMPT_ON_SHARE_PAGE,
  SHOW_DATA_RETENTION_WARNING,
  SHOW_MEMBER_VIDEO_THRESHOLD_BANNER,
  SHOW_CAMFORT_FTUX,
  SHOW_TRANSCRIPT_CORRECTION_FTUX,
  SHOW_CONTINUE_WATCHING_BANNER,
  SHOW_CANVAS_FTUX,
  SHOW_NON_DEFAULT_WORKSPACE_BANNER,
];

export const TRIGGERS_DEFAULTS = {
  [NEW_TRANSCRIPT_EXPERIENCE_VIEWER]: {
    complete: false,
    show: true,
  },
  [NEW_TRANSCRIPT_EXPERIENCE_OWNER]: {
    complete: false,
    show: true,
  },
  [EDUCATION_USER_UPGRADED_MODAL]: {
    show: true,
    complete: false,
  },
  [NEW_ONBOARDING_EXISTING_USER]: {
    complete: false,
    show: false,
  },
  [REQUEST_PUSH_PERMISSIONS]: {
    complete: false,
    show: false,
  },
  [SHOW_AVATAR_TOOLTIP]: {
    complete: false,
    show: false,
  },
  [EMAIL_VERIFIED]: {
    complete: false,
    show: false,
  },
  [DESKTOP_STOP_REC_TOOLTIP]: {
    complete: false,
    show: false,
  },
  [TRIAL_USE_PRO_FEATURE_CUSTOM_DIMENSIONS]: {
    complete: false,
    show: false,
  },
  [TRIAL_USE_PRO_FEATURE_HD_RECORDINGS]: {
    complete: false,
    show: false,
  },
  [CHROME_EXT_TRIAL_PRO_FEATURES_WARN_BANNER]: {
    complete: false,
    show: false,
  },
  [CHROME_EXT_PRO_TRIAL_OVERLAY_MODAL]: {
    complete: false,
    show: false,
  },
  [CHROME_EXT_TRIAL_ENDED_PRE_REC_MENU_BANNER]: {
    complete: false,
    show: false,
  },
  [DESKTOP_TRIAL_ENDED_PRE_REC_MENU_BANNER]: {
    complete: false,
    show: false,
  },
  [SHOW_NEW_GET_STARTED_CHECKLIST_BANNER]: {
    complete: false,
    show: false,
  },
  [GMAIL_INTEGRATION_SHARE_PAGE_UPSELL]: {
    complete: false,
    show: false,
  },
  [EXTENSION_GMAIL_INTEGRATION_COMPOSER_TOOLTIP]: {
    complete: false,
    show: false,
  },
  [LOOM_GREETINGS_STARTUP_INSTRUCTION_MODAL]: {
    complete: false,
    show: true,
  },
  [LOOM_GREETINGS_RECORDING_INSTRUCTION_TOOLTIP]: {
    complete: false,
    show: false,
  },
  [SHOW_FIRST_VIDEO_SHARE_MODAL]: {
    complete: false,
    show: true,
  },
  [SHOW_GET_STARTED_CHECKLIST]: {
    complete: false,
    show: true,
  },
  [SHOW_FIRST_CAPTION_EXPERIENCE]: {
    complete: false,
    show: true,
  },
  [SHOW_DOWNLOAD_VIDEO_INFO_MODAL]: {
    complete: false,
    show: true,
  },
  [SHOW_WEB_PERMISSIONS_PROMPT]: {
    complete: false,
    show: true,
  },
  [SHOW_FIRST_FILLER_REMOVAL_EXPERIENCE]: {
    complete: false,
    show: true,
  },
  [SHOW_MOBILE_BANNER_PROMPT_ON_SHARE_PAGE]: {
    complete: false,
    show: true,
  },
  [SHOW_MEMBER_VIDEO_THRESHOLD_BANNER]: {
    complete: false,
    show: true,
  },
  [SHOW_DATA_RETENTION_WARNING]: {
    complete: false,
    show: true,
  },
  [SHOW_CAMFORT_FTUX]: {
    complete: false,
    show: true,
  },
  [SHOW_TRANSCRIPT_CORRECTION_FTUX]: {
    complete: false,
    show: true,
  },
  [SHOW_CONTINUE_WATCHING_BANNER]: {
    complete: false,
    show: true,
  },
  [SHOW_CANVAS_FTUX]: {
    complete: false,
    show: true,
  },
};
